import React, { useState } from 'react';
import Modal from '../../../components/Modal';
import TimeInput from '../../../components/common/TimeInput';
import { getMeetingDisplayName } from '../utils/meetingTemplates';

const ProposeTimesModal = ({
  isOpen,
  onClose,
  meeting,
  onPropose
}) => {
  const [proposals, setProposals] = useState([
    { date: '', time: '' },
    { date: '', time: '' },
    { date: '', time: '' }
  ]);
  const [proposalMessage, setProposalMessage] = useState('');
  const [sending, setSending] = useState(false);

  const hasValidProposals = () => {
    return proposals.some(p => p.date && p.time);
  };

  const handleSendProposals = async () => {
    const validProposals = proposals.filter(p => p.date && p.time);
    if (validProposals.length === 0) {
      alert('Ange minst ett tidsförslag');
      return;
    }

    try {
      setSending(true);
      await onPropose(meeting._id, validProposals, proposalMessage);
      onClose();
    } catch (err) {
      console.error('Fel vid skickande av tidsförslag:', err);
      alert(err.response?.data?.message || 'Kunde inte skicka tidsförslag');
    } finally {
      setSending(false);
    }
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="small">
          {/* Header */}
          <div className="bg-gray-50 px-6 py-4 border-b">
            <div>
              <h2 className="text-lg font-semibold text-gray-900">
                Föreslå nya tider
              </h2>
              <p className="text-sm text-gray-500 mt-1">
                {meeting.type === 'intromote' ? 'Intromöte (30 min)' : getMeetingDisplayName(meeting)}
              </p>
            </div>
          </div>

          {/* Content */}
          <div className="px-6 py-4">
            <div className="space-y-4">
              <p className="text-sm text-gray-600">
                Tidigare tidsförslag tas bort och nya skickas till deltagarna.
              </p>

              {proposals.map((proposal, index) => (
                <div key={index} className="flex gap-3">
                  <div className="flex-1">
                    <label className="block text-xs text-gray-500 mb-1">
                      Förslag {index + 1} - Datum
                    </label>
                    <input
                      type="date"
                      value={proposal.date}
                      onChange={(e) => {
                        const newProposals = [...proposals];
                        newProposals[index] = { ...newProposals[index], date: e.target.value };
                        setProposals(newProposals);
                      }}
                      min={new Date().toISOString().split('T')[0]}
                      className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-1 focus:ring-primary focus:border-primary"
                    />
                  </div>
                  <div className="w-32">
                    <label className="block text-xs text-gray-500 mb-1">Tid</label>
                    <TimeInput
                      value={proposal.time}
                      onChange={(e) => {
                        const newProposals = [...proposals];
                        newProposals[index] = { ...newProposals[index], time: e.target.value };
                        setProposals(newProposals);
                      }}
                      className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-1 focus:ring-primary focus:border-primary"
                    />
                  </div>
                </div>
              ))}

              {meeting.type !== 'intromote' && (
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Meddelande till deltagare (valfritt)
                  </label>
                  <textarea
                    value={proposalMessage}
                    onChange={(e) => setProposalMessage(e.target.value)}
                    placeholder="T.ex. 'Välj den tid som passar dig bäst...'"
                    rows={2}
                    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-1 focus:ring-primary focus:border-primary"
                  />
                </div>
              )}
            </div>
          </div>

          {/* Footer */}
          <div className="bg-gray-50 px-6 py-4 border-t flex justify-end gap-3">
            <button
              onClick={onClose}
              className="px-4 py-2 text-gray-700 bg-white border border-gray-300 rounded-lg hover:bg-gray-50"
            >
              Avbryt
            </button>
            <button
              onClick={handleSendProposals}
              disabled={sending || !hasValidProposals()}
              className="px-4 py-2 bg-primary text-white rounded-lg hover:bg-primary/90 disabled:opacity-50"
            >
              {sending ? 'Skickar...' : 'Skicka tidsförslag'}
            </button>
          </div>
    </Modal>
  );
};

export default ProposeTimesModal;
